import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  InputGroup,
  Modal,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import CountriesDropdown from '../countriesdropdown'
import ProvincesDropdown from '../provincesdropdown'
import Loadable from 'react-loading-overlay'
import Validators from '../../utils/validators'
import StatesDropdown from '../statesdropdown'
import Dropdown from '../dropdown'

@observer(['addresses', 'companies', 'globals'])
export default class Addresses extends Component {
  constructor(props) {
    super(props)

    let companyId = this.props.companyId

    

    this.state = {
      defaultBillingAddressId: 0,
      defaultShippingAddressId: 0,
      showAddressModal: false,
      showEditAddressModal: false,
      newAddressTypeId: 0,
      newName: '',
      newAddress: '',
      newCity: '',
      newState: 0,
      newZipCode: '',
      newCountry: 'United States',
      editAddressId: 0,
      editAddressCompanyId: 0,
      editAddressTypeId: 0,
      editAddressName: '',
      editAddressAddress: '',
      editAddressCity: '',
      editAddressState: '',
      editAddressZipCode: '',
      editAddressCountry: 'United States',
      addressTypeDropdown: [],
      loadableState: true
    }

    this.loadAddresses(companyId)
  }

  loadAddresses(companyId) {
    let promises = []

    let p1 = new Promise((resolve, reject) => {
      this.props.addresses.loadCompanyBillingAddresses(companyId, (data) => {
        resolve(data)
      })
    })

    let p2 = new Promise((resolve, reject) => {
      this.props.addresses.loadCompanyShippingAddresses(companyId, (data) => {
        resolve(data)
      })
    })

    promises.push(p1)
    promises.push(p2)

    Promise.all(promises).then((results) => {
      this.setState({
        loadableState: false
      })
    })
  }

  openAddressModal() {
    this.props.addresses.loadAllAddressTypes((addressTypes) => {

      const addressTypeDropdown = [
        ...addressTypes,
        { id: 0, name: 'Both'}
      ];

      this.setState({
        addressTypeDropdown: addressTypeDropdown
      })
    })

    this.setState({
      showAddressModal: true
    })
  }

  closeAddressModal() {
    this.setState({
      showAddressModal: false,
      newCountry: 'United States'
    })
  }

  validateNewAddressForm() {
    if (this.getNewCompanyAddressNameValidationState() == 'error') {
      return false
    }

    if (this.getNewCompanyAddressAddressValidationState() == 'error') {
      return false
    }

    if (this.getNewCompanyAddressCityValidationState() == 'error') {
      return false
    }

    if (this.getNewCompanyAddressZipCodeValidationState() == 'error') {
      return false
    }

    return true
  }

  validateEditAddressForm() {
    if (this.getEditCompanyAddressNameValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanyAddressAddressValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanyAddressCityValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanyAddressZipCodeValidationState() == 'error') {
      return false
    }

    return true
  }

  getNewCompanyAddressNameValidationState() {
    if (this.state && Validators.validString(this.state.newName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyAddressNameValidationState() {
    if (this.state && Validators.validString(this.state.editAddressName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewCompanyAddressAddressValidationState() {
    if (this.state && Validators.validString(this.state.newAddress)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyAddressAddressValidationState() {
    if (this.state && Validators.validString(this.state.editAddressAddress)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewCompanyAddressCityValidationState() {
    if (this.state && Validators.validString(this.state.newCity)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyAddressCityValidationState() {
    if (this.state && Validators.validString(this.state.editAddressCity)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewCompanyAddressZipCodeValidationState() {
    if (this.state && Validators.validString(this.state.newZipCode)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyAddressZipCodeValidationState() {
    if (this.state && Validators.validString(this.state.editAddressZipCode)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  newAddressNameChanged(e) {
    this.setState({
      newName: e.target.value
    })
  }

  editAddressNameChanged(e) {
    this.setState({
      editAddressName: e.target.value
    })
  }

  newAddressAddressChanged(e) {
    this.setState({
      newAddress: e.target.value
    })
  }

  editAddressAddressChanged(e) {
    this.setState({
      editAddressAddress: e.target.value
    })
  }

  newAddressCityChanged(e) {
    this.setState({
      newCity: e.target.value
    })
  }

  editAddressCityChanged(e) {
    this.setState({
      editAddressCity: e.target.value
    })
  }

  newAddressZipCodeChanged(e) {
    this.setState({
      newZipCode: e.target.value
    })
  }

  editAddressZipCodeChanged(e) {
    this.setState({
      editAddressZipCode: e.target.value
    })
  }

  onAddressTypeChanged(e) {
    this.setState({
      newAddressTypeId: e.target.value
    })
  }

  onEditAddressTypeChanged(e) {
    this.setState({
      editAddressTypeId: e.target.value
    })
  }

  onAddressStateChanged(e) {
    this.setState({
      newState: e.target.value
    })
  }

  onEditAddressStateChanged(e) {
    this.setState({
      editAddressState: e.target.value
    })
  }

  onAddressCountryChanged(e) {
  this.setState({
      newCountry: e.target.value
    })
  }

  onEditAddressCountryChanged(e) {
    this.setState({
      editAddressCountry: e.target.value
    })
  }

  openEditAddressModal(id) {
    this.props.addresses.loadAllAddressTypes((addressTypes) => {

      const addressTypeDropdown = [
        ...addressTypes,
        //{ id: 0, name: 'Both'}
      ];

      this.setState({
        addressTypeDropdown: addressTypeDropdown
      })

      this.props.addresses.loadAddress(id, (data) => {
        this.setState({
          showEditAddressModal: true,
          editAddressId: data.id,
          editAddressCompanyId: this.props.companyId,
          editAddressTypeId: data.addressTypeId,
          editAddressName: data.name,
          editAddressAddress: data.address,
          editAddressCity: data.city,
          editAddressState: data.state,
          editAddressZipCode: data.zipCode,
          editAddressCountry: data.country,
        })
      })
    })
  }

  closeEditAddressModal() {
    this.setState({
      showEditAddressModal: false,
      editAddressId: 0,
      editAddressCompanyId: 0,
      editAddressTypeId: 0,
      editAddressName: '',
      editAddressAddress: '',
      editAddressCity: '',
      editAddressState: '',
      editAddressZipCode: '',
      editAddressCountry: 'United States',
    })
  }

  saveNewAddress(e) {
    if (this.validateNewAddressForm()) {
      switch (document.getElementById('newAddressTypeId').value) {
        case '0':
          this.processSaveAddressRequest(1)
          this.processSaveAddressRequest(2)
          break

        case '1':
          this.processSaveAddressRequest(1)
          break
        
        case '2':
          this.processSaveAddressRequest(2)
          break
      }

      this.closeAddressModal()
    } else {
      alert('Please check the form.  Required data is missing.')
    }
  }

  processSaveAddressRequest(type) {  
      this.props.addresses.newAddress(
        this.props.companies.details.id,
        type,
        //document.getElementById('newAddressTypeId').value,
        document.getElementById('newName').value,
        document.getElementById('newAddress').value,
        document.getElementById('newCity').value,
        document.getElementById('newState').value,
        document.getElementById('newZipCode').value,
        this.state.newCountry
      )
  }

  copyBillingAddress(row) {
    this.setState({
      loadableState: true
    })

    this.props.addresses.newAddress(
      this.props.companies.details.id,
      2, //Copying billing address to create a new shipping address which has an id of 2 = shipping
      row.name,
      row.address,
      row.city,
      row.state,
      row.zipCode,
      row.country,
      ()  => {
        alert('Address has been successfully copied.')
        this.setState({
          loadableState: false
        })
      }
    )
  }

  copyShippingAddress(row) {
    this.setState({
      loadableState: true
    })

    this.props.addresses.newAddress(
      this.props.companies.details.id,
      1, //Copying shipping address to create a new billing address which has an id of 1 = billing
      row.name,
      row.address,
      row.city,
      row.state,
      row.zipCode,
      row.country,
      () => {
        alert('Address has been successfully copied.')
        this.setState({
          loadableState: false
        })
      }
    )
  }

  saveDefaultBillingAddress(e) {
    this.setState({
      loadableState: true
    })
    this.props.companies.setDefaultBillingAddressId(this.props.companyId, e, (data) => {
      if (this.props.qbCustomerId > 0) {
        this.props.updateQuickbooksCustomer((data) => {
            if(data.quickbooksUpdateCustomer.statusCode == 200) {
              this.props.addresses.loadCompanyBillingAddresses(this.props.companyId)
              alert('Default Billing Address Updated')
              this.setState({
                loadableState: false
              })
            } else {
                alert( data.quickbooksUpdateCustomer.data.message )
                this.setState({
                  loadableState: false
                })
            }
        })
      } else {
        this.props.addresses.loadCompanyBillingAddresses(this.props.companyId)
        alert('Default Billing Address Updated')
        this.setState({
          loadableState: false
        })
      }
    })
    this.props.onSetDefaultBillingAddressId(e)
  }

  saveDefaultShippingAddress(e) {
    this.setState({
      loadableState: true
    })
    this.props.companies.setDefaultShippingAddressId(this.props.companyId, e, (data) => {
      if (this.props.qbCustomerId > 0) {
        this.props.updateQuickbooksCustomer((data) => {
            if(data.quickbooksUpdateCustomer.statusCode == 200) {
              this.props.addresses.loadCompanyShippingAddresses(this.props.companyId)
              alert('Default Shipping Address Updated')
              this.setState({
                loadableState: false
              })
            } else {
                alert( data.quickbooksUpdateCustomer.data.message )
                this.setState({
                  loadableState: false
                })
            }
        })
      } else {
        this.props.addresses.loadCompanyShippingAddresses(this.props.companyId)
        alert('Default Shipping Address Updated')
        this.setState({
          loadableState: false
        })
      }
    })
    this.props.onSetDefaultShippingAddressId(e)
  }

  deleteAddress(id) {
    if (confirm("Are you sure you want to delete this address?")) {
      this.props.addresses.deleteAddress(id, this.props.companyId, localStorage.getItem('userHash'))
    }
  }

  updateAddress() {
    const params = {
      id: this.state.editAddressId,
      companyId: this.state.editAddressCompanyId,
      addressTypeId: this.state.editAddressTypeId,
      name: this.state.editAddressName,
      address: this.state.editAddressAddress,
      city: this.state.editAddressCity,
      state: this.state.editAddressState,
      zipCode: this.state.editAddressZipCode,
      country: this.state.editAddressCountry
    }

    if (this.validateEditAddressForm()) {
      this.setState({
        loadableState: true
      })
      this.props.addresses.updateAddress(params, () => {
        //Update company in quickbooks if a default address was updated.
        if (this.props.qbCustomerId > 0 && (params.id == this.props.defaultBillingAddressId || params.id == this.props.defaultShippingAddressId)) {
          this.props.updateQuickbooksCustomer((data) => {
            if (data.quickbooksUpdateCustomer.statusCode == 200) {
              this.props.addresses.loadCompanyBillingAddresses(this.props.companyId)
              this.props.addresses.loadCompanyShippingAddresses(this.props.companyId)
              alert('Address Updated')
              this.setState({
                loadableState: false
              })
            } else {
              alert(data.quickbooksUpdateCustomer.data.message)
              this.setState({
                loadableState: false
              })
            }
          })
        } else {
          this.props.addresses.loadCompanyBillingAddresses(this.props.companyId)
          this.props.addresses.loadCompanyShippingAddresses(this.props.companyId)
          alert('Address Updated')
          this.setState({
            loadableState: false
          })
        }
        this.closeEditAddressModal()
      })
    } else {
      alert('Please check the form.  Required data is missing.')
    }
  }

  formatBillingActions(cell, row) {
    let setDefaultButton = (<Button bsSize="small" disabled={true}><i className="fa fa-check" aria-hidden="true"></i></Button>)
    let setDeleteButton = (<Button bsSize="small" disabled={true}><i className="fa fa-trash" aria-hidden="true"></i></Button>)

    if (this.props.defaultBillingAddressId) {
      if (cell != this.props.defaultBillingAddressId) {
        setDefaultButton = (<Button bsSize="small" bsStyle="success" onClick={(e) => { this.saveDefaultBillingAddress(cell) }}><i className="fa fa-check" aria-hidden="true"></i></Button>)
        setDeleteButton = (<Button bsSize="small" bsStyle="danger" id={cell} onClick={() => { this.deleteAddress(cell) }}><i className="fa fa-trash" aria-hidden="true"></i></Button>)
      }
    }

    return (<div>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'setBillingDefault-' + cell}>Set As Default</Tooltip> }>{setDefaultButton}</OverlayTrigger>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'setBillingEdit-' + cell}>Edit Address</Tooltip> }><Button bsSize="small" bsStyle="warning" onClick={(e) => { this.openEditAddressModal(cell) }}><i className="fa fa-pencil" aria-hidden="true"></i></Button></OverlayTrigger>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'setBillingCopy-' + cell}>Copy Address to Shipping</Tooltip> }><Button bsSize="small" bsStyle="info" onClick={(e) => { this.copyBillingAddress(row) }}><i className="fa fa-copy" aria-hidden="true"></i></Button></OverlayTrigger>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'setBillingDelete-' + cell}>Delete Address</Tooltip> }>{setDeleteButton}</OverlayTrigger>
    </div>)
  }

  formatShippingActions(cell, row) {
    let setDefaultButton = (<Button bsSize="small" disabled={true}><i className="fa fa-check" aria-hidden="true"></i></Button>)
    let setDeleteButton = (<Button bsSize="small" disabled={true}><i className="fa fa-trash" aria-hidden="true"></i></Button>)

    if (this.props.defaultShippingAddressId) {
      if (cell != this.props.defaultShippingAddressId) {
        setDefaultButton = (<Button bsSize="small" bsStyle="success" onClick={(e) => { this.saveDefaultShippingAddress(cell) }}><i className="fa fa-check" aria-hidden="true"></i></Button>)
        setDeleteButton = (<Button bsSize="small" bsStyle="danger" id={cell} onClick={() => { this.deleteAddress(cell) }}><i className="fa fa-trash" aria-hidden="true"></i></Button>)
      }
    }

    return (<div>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'setShippingDefault-' + cell}>Set As Default</Tooltip> }>{setDefaultButton}</OverlayTrigger>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'setShippingEdit-' + cell}>Edit Address</Tooltip> }><Button bsSize="small" bsStyle="warning" onClick={(e) => { this.openEditAddressModal(cell) }}><i className="fa fa-pencil" aria-hidden="true"></i></Button></OverlayTrigger>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'setShippingCopy-' + cell}>Copy Address to Billing</Tooltip> }><Button bsSize="small" bsStyle="info" onClick={(e) => { this.copyShippingAddress(row) }}><i className="fa fa-copy" aria-hidden="true"></i></Button></OverlayTrigger>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'setShippingDelete-' + cell}>Delete Address</Tooltip> }>{setDeleteButton}</OverlayTrigger>
    </div>)
  }

  render() {
    const stateDropdown = (this.state.newCountry == 'United States')
    ? (
      <FormGroup>
        <Col sm={12}><StatesDropdown id="newState" onChange={this.onAddressStateChanged.bind(this)} /></Col>
      </FormGroup>
    ) : (
      <FormGroup>
        <Col sm={12}><ProvincesDropdown id="newState" onChange={this.onAddressStateChanged.bind(this)} /></Col>
      </FormGroup>
    );

    let editStateDropdown = <FormGroup>
      <Col sm={12}><StatesDropdown id="editAddressState" defaultValue={this.state.editAddressState} onChange={this.onEditAddressStateChanged.bind(this)} /></Col>
    </FormGroup>
    
    if (this.state.editAddressCountry === 'Canada') {
      editStateDropdown = <FormGroup>
        <Col sm={12}><ProvincesDropdown id="editAddressState" defaultValue={this.state.editAddressState} onChange={this.onEditAddressStateChanged.bind(this)} /></Col>
      </FormGroup>
    }

    const options = {
      sizePerPage: 5,
      sizePerPageList: [5, 15, 25, 50]
    }

    const billingAddressTable = (
      <div>
        <Button bsStyle="info" onClick={this.openAddressModal.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> New</Button>
        <div>
          <span><strong>Billing Addresses</strong></span>
        </div>
        <BootstrapTable
          data={this.props.addresses.billingAddresses}
          striped={true}
          hover={true}
          pagination={true}
          search={true}
          options={options}
          bordered={false}
        >
          <TableHeaderColumn width="50" dataField="id" isKey={true} dataSort={true} dataAlign="center" hiddenOnInsert={true} autoValue={true}>ID</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="name" dataSort={true} editable={false}>Name</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="address" dataSort={true}>Address</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="city" editable={false} hiddenOnInsert={true} dataSort={true}>City</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="state" editable={false} hiddenOnInsert={true} dataSort={true}>State</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="zipCode" editable={false} hiddenOnInsert={true} dataSort={true}>Zip Code</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="country" editable={false} hiddenOnInsert={true} dataSort={true}>Country</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={true} autoValue={true} dataFormat={this.formatBillingActions.bind(this)}>Actions</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )

    const shippingAddressTable = (
      <div>
        <div>
          <span><strong>Shipping Addresses</strong></span>
        </div>
        <BootstrapTable
          data={this.props.addresses.shippingAddresses}
          striped={true}
          hover={true}
          pagination={true}
          search={true}
          options={options}
          bordered={false}
        >
          <TableHeaderColumn width="50" dataField="id" isKey={true} dataSort={true} dataAlign="center" hiddenOnInsert={true} autoValue={true}>ID</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="name" dataSort={true} editable={false}>Name</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="address" dataSort={true}>Address</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="city" editable={false} hiddenOnInsert={true} dataSort={true}>City</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="state" editable={false} hiddenOnInsert={true} dataSort={true}>State</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="zipCode" editable={false} hiddenOnInsert={true} dataSort={true}>Zip Code</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="country" editable={false} hiddenOnInsert={true} dataSort={true}>Country</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={true} autoValue={true} dataFormat={this.formatShippingActions.bind(this)}>Actions</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )

    return (
      <div>
        <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
          <div>
            {billingAddressTable}
          </div>
          <div>
            {shippingAddressTable}
          </div>
        </Loadable>
        <Modal show={this.state.showAddressModal} onHide={this.closeAddressModal.bind(this)} bsSize="small">
          <Modal.Header closeButton>
            <Modal.Title>New Address</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="newAddressForm">
              <FormGroup>
                <Col sm={2} componentClass={ControlLabel}>Type:</Col>
                <Col sm={10}><Dropdown data={this.state.addressTypeDropdown} id="newAddressTypeId" onChange={this.onAddressTypeChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getNewCompanyAddressNameValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="Name" id="newName" onChange={this.newAddressNameChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getNewCompanyAddressAddressValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="Address" id="newAddress" onChange={this.newAddressAddressChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getNewCompanyAddressCityValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="City" id="newCity" onChange={this.newAddressCityChanged.bind(this)} /></Col>
              </FormGroup>
              { stateDropdown }
              <FormGroup validationState={this.getNewCompanyAddressZipCodeValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="Zip Code" id="newZipCode" onChange={this.newAddressZipCodeChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={12}><CountriesDropdown id="newCountry" defaultValue={this.state.newCountry} onChange={this.onAddressCountryChanged.bind(this)} /></Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.closeAddressModal.bind(this)}>Close</Button>
            <Button bsStyle="success" onClick={this.saveNewAddress.bind(this)}>Save</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showEditAddressModal} onHide={this.closeEditAddressModal.bind(this)} bsSize="small">
          <Modal.Header closeButton>
            <Modal.Title>Edit Address</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="editAddressForm">
              <input type="hidden" id="editAddressId" defaultValue={this.state.editAddressId} />
              <input type="hidden" id="editAddressCompanyId" defaultValue={this.state.editAddressCompanyId} />
              <FormGroup>
                <Col sm={2} componentClass={ControlLabel}>Type:</Col>
                <Col sm={10}><Dropdown data={this.state.addressTypeDropdown} defaultValue={this.state.editAddressTypeId} id="editAddressTypeId" onChange={this.onEditAddressTypeChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getEditCompanyAddressNameValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="Name" defaultValue={this.state.editAddressName} id="editAddressName" onChange={this.editAddressNameChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getEditCompanyAddressAddressValidationState()}>
                <Col sm={12}><FormControl type="text" placeholder="Address" defaultValue={this.state.editAddressAddress} id="editAddressAddress" onChange={this.editAddressAddressChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getEditCompanyAddressCityValidationState()}>
                <Col sm={12}><FormControl type="text" placeholder="City" defaultValue={this.state.editAddressCity} id="editAddressCity" onChange={this.editAddressCityChanged.bind(this)} /></Col>
              </FormGroup>
              { editStateDropdown }
              <FormGroup validationState={this.getEditCompanyAddressZipCodeValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="Zip Code" defaultValue={this.state.editAddressZipCode} id="editAddressZipCode" onChange={this.editAddressZipCodeChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={12}><CountriesDropdown id="editAddressCountry" defaultValue={this.state.editAddressCountry} onChange={this.onEditAddressCountryChanged.bind(this)} /></Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.closeEditAddressModal.bind(this)}>Close</Button>
            <Button bsStyle="success" onClick={this.updateAddress.bind(this)}>Save</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/company/addresses.js